// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8d66b8f8","455":"514cae83","977":"45e532d5"}[chunkId] + ".chunk.js";
};